import React, { ReactNode } from "react";
import { Tooltip } from "react-tooltip";

interface IconActionButtonProps {
  title: string;
  icon: ReactNode;
  id?: string;
  onClick: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const ActionButton: React.FC<IconActionButtonProps> = ({
  title,
  icon,
  onClick,
  id = "",
  className = "",
  style = {},
}) => {
  return (
    <>
      <button
        id={id}
        onClick={onClick}
        className={`btn p-0 m-0 border-0 bg-transparent ${className}`}
        style={{ lineHeight: 1, ...style }}
      >
        {icon}
      </button>
      <Tooltip
        anchorSelect={`#${id}`}
        place="top"
        content={title}
        style={{
          zIndex: 999999,
          backgroundColor: "#333",
          color: "#fff",
          fontSize: "12px",
          padding: "6px 10px",
          borderRadius: "4px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      />
    </>
  );
};

export default ActionButton;
